import { useState } from "react";

type ISearchVisits = {
    _handleSearch: (filters: any) => void;
    _handleError: (e: any) => void;
    loading: boolean;
};

const Search = ({ _handleSearch, _handleError, loading }: ISearchVisits) => {
    const [filters, setFilters] = useState({
        fecha_inicio: "",
        fecha_fin: "",
        rol: "",
        visitas: "",
    });

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        try {
            _handleSearch(filters);
        } catch (err: any) {
            _handleError(err);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="card p-10">
                <div className="row fs-4 fw-bold">
                    <div className="col-12 col-md-4 mb-5">
                        <span>Fecha de Registro</span>
                        <div className="row mt-2">
                            <div className="col-6">
                                <input
                                    type="date"
                                    name="fecha_inicio"
                                    className="form-control"
                                    placeholder="Desde"
                                    value={filters.fecha_inicio}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-6">
                                <input
                                    type="date"
                                    name="fecha_fin"
                                    className="form-control"
                                    placeholder="Hasta"
                                    value={filters.fecha_fin}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-4 mb-5">
                        <span>Rol Medisyn</span>
                        <input
                            type="number"
                            name="rol"
                            className="form-control mt-2"
                            placeholder="Ingrese el rol"
                            value={filters.rol}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-12 col-md-4 mb-5">
                        <span>Envío a valorización</span>
                        <select
                            name="visitas"
                            className="form-select mt-2"
                            value={filters.visitas}
                            onChange={handleChange}
                        >
                            <option value="">Todos</option>
                            <option value="S">Si</option>
                            <option value="N">No</option>
                        </select>
                    </div>

                    <div className="col-12 text-end">
                        <button
                            type="submit"
                            className="btn btn-sm fw-bold btn-primaryamsm"
                            disabled={loading}
                        >
                            <i className="fa fa-search me-2"></i>
                            Buscar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default Search;
